import React, { useEffect, useState } from "react";
import {
  Box,
  Fade,
  IconButton,
  Button,
  Modal,
  Typography,
  Checkbox,
  TablePagination,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ToolTipComponent from "../Components/ToolTipComponent";
import { MoneyFormat } from "../../../library/MoneyFormat";
import { showWarningSnackbar } from "../../../components/snackBar/snakbar";
import { useThemes } from "../../../components/Theme/theme";
import { useSelector } from "react-redux";
import { allTaxabilityOptios } from "../Components/InvoiceData";
import { useTaxabilityOptions } from "../Components/UseTaxabilityOptions";
import useSaveModalShortcut from "../Components/useSaveModalShortcut";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  outline: "none",
  width: 1500,
};


function NewItemListModal({
  open,
  setOpen,
  setItems,
  placeOfSupply,
  companyState,
  itemArr,
  invNumber,
  accNames,
  unitsObj,
  partyType,
  registrationType,
  items,
  Type,
  data,
  setItemArr,
}) {
  const rgItemwiseHeader = [
  {
    id: "SL.No",
    label: "SL.No",
    minWidth: 100,
    align: "left",
  },

  {
    id: "Item Code",
    label: "Item Code",
    minWidth: 300,
    align: "left",
  },
  {
    id: "Item Name",
    label: "Item Name",
    minWidth: 300,
    align: "left",
  },
  {
    id: "Price Type",
    label: "Price Type",
    width: 300,
    align: "left",
  },
  {
    id: "Taxability",
    label: "Taxability",
    width: 300,
    align: "left",
  },
  {
    id: "GST Rate",
    label: "GST Rate (%)",
    minWidth: 300,
    align: "left",
  },
  {
    id: "HSN/SAC Code",
    label: "HSN/SAC Code",
    minWidth: 350,
    align: "left",
  },
  {
    id: "Qty",
    label: "Qty",
    minWidth: 200,
    align: "left",
  },
  {
    id: "Units",
    label: "Units",
    minWidth: 350,
    align: "left",
  },
  {
    id: "Rate",
    label: `Rate (${data?.currency?.sign})`,
    minWidth: 300,
    align: "right",
  },
  {
    id: "Amount",
    label: `Amount (${data?.currency?.sign})`,
    minWidth: 300,
    align: "right",
  },
  {
    id: "Discount",
    label: `Discount (${data?.currency?.sign})`,
    minWidth: 300,
    align: "right",
  },
  {
    id: "Taxable Amount",
    label: `Taxable Amount (${data?.currency?.sign})`,
    minWidth: 350,
    align: "right",
  },
  {
    id: "GST",
    label: `GST (${data?.currency?.sign})`,
    minWidth: 200,
    align: "right",
  },
  {
    id: "GST Cess",
    label: `GST Cess (${data?.currency?.sign})`,
    minWidth: 200,
    align: "right",
  },
  {
    id: "Net Amount",
    label: `Net Amount (${data?.currency?.sign})`,
    minWidth: 350,
    align: "right",
  },
];
const unrItemWiseHeader = [
  {
    id: "SL.No",
    label: "SL.No",
    minWidth: 100,
    align: "left",
  },

  {
    id: "Item Code",
    label: "Item Code",
    minWidth: 300,
    align: "left",
  },
  {
    id: "Item Name",
    label: "Item Name",
    minWidth: 300,
    align: "left",
  },
  {
    id: "Price Type",
    label: "Price Type",
    width: 300,
    align: "left",
  },
  {
    id: "Qty",
    label: "Qty",
    minWidth: 200,
    align: "left",
  },
  {
    id: "Units",
    label: "Units",
    minWidth: 350,
    align: "left",
  },
  {
    id: "Rate",
    label: `Rate (${data?.currency?.sign})`,
    minWidth: 300,
    align: "right",
  },
  {
    id: "Amount",
    label: `Amount (${data?.currency?.sign})`,
    minWidth: 300,
    align: "right",
  },
  {
    id: "Discount",
    label: `Discount (${data?.currency?.sign})`,
    minWidth: 300,
    align: "right",
  },
  {
    id: "Taxable Amount",
    label: `Taxable Amount (${data?.currency?.sign})`,
    minWidth: 350,
    align: "right",
  },

  {
    id: "Net Amount",
    label: `Net Amount (${data?.currency?.sign})`,
    minWidth: 350,
    align: "right",
  },
];

  const { theme } = useThemes();
   const {
      allTaxabilityOptions,
    } = useTaxabilityOptions();

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [selected, setSelected] = useState([]);
  const [itemRows, setItemRows] = useState([]);
  const [selectedTaxability, setSelectedTaxability] = useState([]);

  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );

  let EInvoiceFlag = getCompany?.relatedcompanydetailsnew?.[0]?.einvoiceflag;
  let companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
  const itemWiseHeader =
    companyType == 1 ? unrItemWiseHeader : rgItemwiseHeader;

  // const handleClose = (event, reason) => {
  //   if (reason !== "backdropClick") {
  //     setOpen(false);
  //   }
  // };
 const handleClose = (event, reason) => {
  if (reason !== "backdropClick") {
    
    // Reset checkbox state
    setItemArr((prev) => prev.map((obj) => ({ ...obj, checked: false })));
    setItemRows((prev) => prev.map((obj) => ({ ...obj, checked: false })));

    setSelected([]);
    setSelectedTaxability([]);

    setOpen(false);
  }
};



  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  const handleClick = (event,name, col) => {
    const selectedIndex = selected.indexOf(col.itemNo);
    let newSelected = [...selected];
    let newTaxability = [...selectedTaxability];

    if (selectedIndex === -1) {
      // Ensure that the new taxability matches the existing selection
      if (newTaxability.length > 0 && !newTaxability.includes(col.taxability?.vlue)) {
        showWarningSnackbar(
          "You can only select items with the same taxability."
        );
        return;
      }
      newSelected = newSelected.concat(selected, col.itemNo);
      newTaxability = newTaxability.concat(col.taxability?.vlue);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
      newTaxability = newTaxability.slice(1);
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
      newTaxability = newTaxability.slice(0, -1);
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
      newTaxability = newTaxability
        .slice(0, selectedIndex)
        .concat(newTaxability.slice(selectedIndex + 1));
    }
    const entryRows = [...itemArr];
    const updatedTableArr = [...itemRows];
    updatedTableArr[name] = {
      ...updatedTableArr[name],
      checked: event.target.checked,
    };

    entryRows[name] = {
      ...entryRows[name],
      checked: event.target.checked,
    };
    
    setItemArr(entryRows);
    setItemRows(updatedTableArr);
    const uniqueSelected = [...new Set(newSelected)];
    setSelected(uniqueSelected);
    setSelectedTaxability(newTaxability);
  };

  const addItemwiseRows = () => {
    const taxTypes =
      partyType === "CUSTOMER" || Type === "Pos"
        ? [2, 3, 5, 4, 7, 9]
        : [2, 3, 5, 7, 9];

    if (selected?.length > 0) {
      let arr = items.filter(
        (item) => !item.checked && item?.itemCode?.value !== ""
      );   
      selected.map((item2, index) => {
        const matchingItem = itemRows.find(
          (item1, index) =>
            (item1.itemNo == item2) && item1?.checked
        );

        if (matchingItem) {
          arr.push(matchingItem);
        }
      });
      arr?.forEach((ele) => {
        ele.netAmount =
          taxTypes.includes(data?.taxability?.value) || (companyType === 3 && partyType==="CUSTOMER")
            ? ele?.taxableAMount
            : ele?.netAmount;
      });

      setItems(arr);
      setOpen(false);
    } else {
      let arr = items.filter((item) => !item.checked);
      arr?.forEach((ele) => {
        ele.netAmount =
          taxTypes.includes(data?.taxability?.value) || (companyType === 3 && partyType==="CUSTOMER")
            ? ele?.taxableAMount
            : ele?.netAmount;
      });

      setItems(arr);
      showWarningSnackbar("Please select at least one line item before saving.");
      setOpen(true);
    }
  };

  async function getItemDetails(itemArr) {
    try {
      let itemAmountArr = [];
      if (partyType === "SUPPLIER") {
        itemArr.map(async (ele) => {
          if(ele?.gstrate>0){
          ele.igstAmt =
            Number(ele.itemquantity) * Number(ele.itemrate) -
            Number(ele.itemdiscount);
          ele.igstAmt = (Number(ele.igstAmt) * Number(ele.gstrate)) / 100;
          ele.igstAmt = Number(ele.igstAmt) / 2;
          ele.igstAmt = Math.round(ele.igstAmt * 100) / 100;
          ele.igstAmt = ele.igstAmt * 2;
          }else{
              ele.igstAmt=0;
          }
          
          let itemName = {};
          let itemCodeObj = {};
          let accountobj = {};
          let hsnCode = {
            label: "",
            value: "",
            companyID: "",
            hsnID: "",
            codeType: "",
            description: "",
          };
          let hsnobj254 = {};
          let priceObj = {};
          priceObj = { label: ele.pricetype, value: ele.pricetypeid };
          if (ele.hsncode !== null && ele.hsncode != 0) {
            hsnCode = {
              label: `${ele.hsncode} - ${ele.hsndescription}`,
              value: `${ele.hsncode}`,
              companyID: ele?.companyid,
              hsnID: ele.hsnsacid,
              codeType: ele.hsncodetype,
              description: ele.hsndescription,
            };
          }

          itemName = { label: ele.itemname, value: ele.itemid };
          itemCodeObj = { label: ele.itemcode, value: ele.itemid };
          accNames.map((code) => {
            if (code.value === ele.purchaseaccountid) {
              accountobj = { label: code.label, value: code.value };
            }
          });
          let taxType = { label: "", value: "" };
          allTaxabilityOptions.map((type) => {
            if (type.value == ele?.taxability)
              taxType = { label: type?.label, value: type?.value };
          });
          itemAmountArr.push({
            itemCode: itemCodeObj,
            name: itemName,
            ledgerAccount: accountobj,
            HSN: hsnCode,
            qty: ele.itemquantity,
            units: ele.unittypecd,
            rate: ele.itemrate,
            amount: ele.itemamount,
            dicount: ele.itemdiscount,
            taxability: taxType,
            reason:"",
            taxableAMount:
              Number(ele.itemquantity) * Number(ele.itemrate) -
              Number(ele.itemdiscount),
            GSTRate: ele?.gstrate,
            IGST: Number(ele.igstAmt),
            CGST: "0",
            SGST: "0",
            GSTCess: ele?.cessamount,
            priceType: priceObj,
            netAmount:
              Number(ele.itemquantity) * Number(ele.itemrate) -
              Number(ele.itemdiscount) +
              Number(ele.cessamount) +
              Number(ele.igstAmt),
            selected: true,
            editable: false,
            new: false,
            checked: ele.checked ? ele.checked : false,
            itemNo: ele.itemNo,
            manualGSTFlag:ele?.manualgst,
            manualCess:ele?.manualcess,
            cessRate:ele?.cessrate,
            cessType:ele?.cesstype,
            manualDiscount: ele?.manualdiscount == 1 ? true : false,
             discountType:ele?.itemdiscounttype,
            discountRate:ele.itemdiscountrate,
              itemType:ele?.itemtype

          });
        });
      }
      if (partyType === "CUSTOMER") {
        itemArr.map(async (ele) => {
            if(ele?.gstrate>0){
          ele.igstAmt =
            Number(ele.quantity) * Number(ele.itemrate) -
            Number(ele.itemdiscount);
          ele.igstAmt = (Number(ele.igstAmt) * Number(ele.gstrate)) / 100;
          ele.igstAmt = Number(ele.igstAmt) / 2;
          ele.igstAmt = Math.round(ele.igstAmt * 100) / 100;
          ele.igstAmt = ele.igstAmt * 2;
            }else{
                ele.igstAmt=0;
            }
          let itemName = {};
          let itemCodeObj = {};
          let accountobj = {};
          let hsnCode = {
            label: "",
            value: "",
            companyID: "",
            hsnID: "",
            codeType: "",
            description: "",
          };
          let hsnobj254 = {};
          let priceObj = {};
          priceObj = { label: ele.pricetype, value: ele.pricetypeid };
          if (ele.hsnsaccode !== 0 && ele.hsnsaccode !== null) {
            hsnCode = {
              label: `${ele.hsnsaccode} - ${ele.hsndescription}`,
              value: `${ele.hsnsaccode}`,
              companyID: ele?.companyid,
              hsnID: ele.hsnsacid,
              codeType: ele.hsncodetype,
              description: ele.hsndescription,
            };
          }

          itemName = { label: ele.itemname, value: ele.itemid };
          itemCodeObj = { label: ele.itemcode, value: ele.itemid };
          accNames.map((code) => {
            if (code.value === ele.salesaccountid) {
              accountobj = { label: code.label, value: code.value };
            }
          });
          let taxType = { label: "", value: "" };
          allTaxabilityOptions.map((type) => {
            if (type.value == ele?.taxability)
              taxType = { label: type?.label, value: type?.value };
          });
          itemAmountArr.push({
            itemCode: itemCodeObj,
            name: itemName,
            ledgerAccount: accountobj,
            HSN: hsnCode,
            qty: ele.quantity,
            units: ele.unittypecd,
            rate: ele.itemrate,
            amount: ele.itemamount,
            dicount: ele.itemdiscount,
            taxability: taxType,
            reason:"",
            taxableAMount:
              Number(ele.quantity) * Number(ele.itemrate) -
              Number(ele.itemdiscount),
            GSTRate: ele?.gstrate,
            IGST: Number(ele.igstAmt),
            CGST: "0",
            SGST: "0",
            GSTCess: ele?.cessamount,
            priceType: priceObj,
            netAmount:
              Number(ele.quantity) * Number(ele.itemrate) -
              Number(ele.itemdiscount) +
              Number(ele.cessamount) +
              Number(ele.igstAmt),
            editable: false,
            selected: true,
            new: false,
            checked: ele.checked ? ele.checked : false,
            itemNo: ele.itemNo,
            manualGSTFlag:ele?.manualgst,
            manualCess:ele?.manualcess,
            cessRate:ele?.cessrate,
            cessType:ele?.cesstype,
            manualDiscount: ele?.manualdiscount == 1 ? true : false,
                discountType:ele?.itemdiscounttype,
            discountRate:ele.itemdiscountrate,
            itemType:ele?.itemtype
          });
        });
      }
      let arr=[]
      itemAmountArr.map((ele)=>{
        items.map((subele)=>{
          if(ele.itemNo==subele.itemNo){
            ele.checked=true
            arr.push(ele.itemNo)
          }

        })
      })
      setSelected(arr)
      setItemRows(itemAmountArr);
    } catch (error) {
      console.log("error", error);
    }
  }

  // useEffect(() => {
  //   getItemDetails(itemArr);
  // }, []);
  useEffect(() => {
  if (open) {
    getItemDetails(itemArr);
  }
}, [open]);
  
  useEffect(() => {
  if (items.length === 0) {
    setItemArr((prev) =>
      prev.map((obj) => ({
        ...obj,
        checked: false,
      }))
    );

    setItemRows((prev) =>
      prev.map((obj) => ({
        ...obj,
        checked: false,
      }))
    );
  }
}, [items]);


    useSaveModalShortcut(addItemwiseRows);
  return (
    <Modal
      id={open?"DisplayLineItem":""}
      sx={{ width: "200px 200px" }}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={handleClose}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              height: "100%",
              // height: 500,
            }}
          >
            <Box
              sx={{
                backgroundColor: "primary.main",
                padding: "5px 15px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {"Item-Wise Entry"}
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: "#fff" }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>

            <Box sx={{ padding: { xs: "10px 10px", sm: "10px 20px" } }}>
              <TableContainer
                component={Paper}
                aria-setsize="small"
                sx={{
                  ".MuiTableContainer-root": {
                    overflowY: "scroll",
                  },
                  width: "100%",
                  height: 500,
                  "&::-webkit-scrollbar": {
                    width: "0.4em",
                    height: "0.4em",
                  },
                }}
              >
                <Table
                  // component={Paper}
                  sx={{}}
                  aria-label="simple table"
                  stickyHeader
                >
                  <TableHead sx={{ color: theme.palette.secondary.main }}>
                    <TableRow sx={{ height: "24px" }}>
                      {" "}
                      {/* Decreased height */}
                      <TableCell
                        padding="checkbox"
                        sx={{
                          ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root": {
                            // Adjust checkbox padding if needed
                          },
                          backgroundColor: "primary.main",
                          padding: "0px", // Remove extra padding
                          height: "24px", // Ensure consistent height
                        }}
                      ></TableCell>
                      {itemWiseHeader.map((column, ind) => {
                        return (
                          <TableCell
                            key={ind}
                            align={column.align}
                            minWidth={column.minWidth}
                            sx={{
                              backgroundColor: "primary.main",
                              color: "#FFF",
                              fontSize: "12px",
                              padding: "2px 8px", // Reduce padding for compact design
                              height: "24px", // Adjust height
                              ".MuiTableCell-head": {
                                borderBottom: "0px",
                                height: "24px",
                              },
                            }}
                          >
                            {column.label}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {stableSort(itemRows, getComparator(order, orderBy))
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((col, index) => {
                        const isItemSelected = isSelected(index);
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            sx={{ height: "30px" }}
                            key={index}
                          >
                            <TableCell
                              padding="checkbox"
                              sx={{
                                ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root":
                                  {
                                    padding: "5px",
                                  },
                              }}
                            >
                              <Checkbox
                                onClick={(event) => {
                                  event.stopPropagation();
                                  handleClick(
                                    event,
                                    index,
                                    col
                                  );
                                }}
                                color="primary"
                                checked={col.checked}
                                inputProps={{
                                  "aria-labelledby": labelId,
                                }}
                                size="small"
                              />
                            </TableCell>
                            <TableCell align="left">{index + 1}</TableCell>
                            <TableCell align="left">
                              {col.itemCode.label}
                            </TableCell>
                            <TableCell align="left">{col.name.label}</TableCell>
                            <TableCell align="left">
                              {col.priceType.label}
                            </TableCell>
                            {companyType != 1 && (
                              <>
                                <TableCell align="left">
                                  {col.taxability?.label}
                                </TableCell>
                                <TableCell align="right">
                                  {col.GSTRate > 0 ? col.GSTRate : Number(col.GSTRate) === -1 ? "NIL" : 0}
                                </TableCell>
                                <TableCell align="left">
                                  {col.HSN.value}
                                </TableCell>
                              </>
                            )}
                            <TableCell align="right">{col.qty}</TableCell>
                            <TableCell align="left">
                              {unitsObj[col.units]}
                            </TableCell>
                            <TableCell align="right">
                              {MoneyFormat(
                                col.rate == ""
                                  ? 0
                                  : Number(col.rate).toFixed(2),
                                "en-IN"
                              )}
                            </TableCell>
                            <TableCell align="right">
                              {MoneyFormat(
                                col.amount == ""
                                  ? 0
                                  : Number(col.amount).toFixed(2),
                                "en-IN"
                              )}
                            </TableCell>
                            <TableCell align="right">
                              {MoneyFormat(
                                col.dicount == ""
                                  ? 0
                                  : Number(col.dicount).toFixed(2),
                                "en-IN"
                              )}
                            </TableCell>

                            <>
                              <TableCell align="right">
                                {MoneyFormat(
                                  col.taxableAMount == ""
                                    ? 0
                                    : Number(col.taxableAMount).toFixed(2),
                                  "en-IN"
                                )}
                              </TableCell>
                              {companyType != 1 && (
                                <>
                                  <TableCell align="right">
                                    <ToolTipComponent
                                      title={
                                        
                                        placeOfSupply == companyState ? (
                                          <Typography
                                            sx={{
                                              display: "flex",
                                              flexDirection: "column",
                                            }}
                                          >
                                            <span>
                                              CGST :{" "}
                                              { col.GSTRate>0?MoneyFormat(
                                                (Number(col.taxableAMount) *
                                                  Number(col.GSTRate / 100)) /
                                                  2,
                                                "en-IN"
                                              ):"0.00"}
                                            </span>
                                            <span>
                                              SGST :{" "}
                                              { col.GSTRate>0?MoneyFormat(
                                                (Number(col.taxableAMount) *
                                                  Number(col.GSTRate / 100)) /
                                                  2,
                                                "en-IN"
                                              ):"0.00"}
                                            </span>
                                          </Typography>
                                        ) : (
                                          <Typography>
                                            <span>
                                              IGST :
                                              {col.GSTRate>0?MoneyFormat(
                                                Number(col.taxableAMount) *
                                                  Number(col.GSTRate / 100),
                                                "en-IN"
                                              ):"0.00"}
                                            </span>
                                          </Typography>
                                        )
                                      }
                                      tooltipContent={col.GSTRate>0?MoneyFormat(
                                        Number(col.taxableAMount) *
                                          Number(col.GSTRate / 100),
                                        "en-IN"
                                      ):"0.00"}
                                    />
                                  </TableCell>
                                </>
                              )}
                              {companyType != 1 && (
                                <>
                                  <TableCell align="right">
                                    {MoneyFormat(
                                      col.GSTCess == ""
                                        ? 0
                                        : Number(col.GSTCess).toFixed(2),
                                      "en-IN"
                                    )}
                                  </TableCell>
                                </>
                              )}
                            </>

                            <TableCell align="right">
                              {MoneyFormat(
                                col.netAmount == ""
                                  ? 0
                                  : Number(col.netAmount).toFixed(2),
                                "en-IN"
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <TablePagination
              sx={{
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": {
                  // width: '0.4em',
                  height: "0.2em",
                },
                "&::-webkit-scrollbar-track": {
                  background: `${theme.palette.primary.main}47`,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "primary.main",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: `${theme.palette.primary.main}47`,
                },
              }}
              rowsPerPageOptions={[10, 20, 50]}
              component="div"
              count={itemRows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
            <Box
              sx={{
                marginTop: "10px",
                width: "100%",
                display: "flex",
                justifyContent: { xs: "space-around", sm: "end" },
                flexWrap: "wrap",
                flexDirection: { xs: "column", sm: "row" },
                zIndex: 1,
              }}
            >
              <Box
                sx={{
                  marginTop: "10px",
                  width: "100%",
                  display: "flex",
                  justifyContent: { xs: "space-around", sm: "end" },
                  flexWrap: "wrap",
                  flexDirection: { xs: "column", sm: "row" },
                  marginRight: { sm: "20px" },
                }}
              >
                <Button
                  variant="contained"
                  disableElevation
                  disableRipple
                  sx={{
                    fontSize: "12px",
                    marginBottom: "15px",
                    marginLeft: { xs: "0px", sm: "20px" },
                  }}
                  onClick={addItemwiseRows}
                >
                  Save
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default NewItemListModal;
